/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {ActionSheet} from 'react-weui'

class BanListItem extends React.Component {
    static defaultProps = {
        content: {
            small_avatar_url: '',
            nickname: '',
        },
        hasBtn: true
    };

    constructor() {
        super();
        this.state = {
            actionSheetShow: false,
            manageMenus: [
                {
                    label: '设为直播间客服',
                    onClick: this.handleBeConsulter.bind(this)
                },
                {
                    label: '移除直播间管理员',
                    onClick: this.hendleBeforeDeleteManage.bind(this)
                }
            ],
            actionBottom: [
                {
                    label: '取消',
                    onClick: this.handleSheetHide.bind(this)
                }
            ]
        }
        this.handleSheetShow = this.handleSheetShow.bind(this);
        this.handleBan = this.handleBan.bind(this);
    }

    handleSheetShow() {
        this.setState({
            actionSheetShow: true
        })
    }

    handleSheetHide() {
        this.setState({
            actionSheetShow: false
        })
    }

    handleChangeList() {
        const {content, liveroomSetting} = this.props;
        let data = new FormData();
        data.append('account_id', content.id);
        axios.post(`/api/liveroom/${liveroomSetting.liveroom_id}/unblock_account`, data)
            .then(res => {
                if (res.data.code === 0) {
                    let list = liveroomSetting.liveroomBanList;
                    let index = list.findIndex((value) => {
                        return content.id === value.id
                    });
                    list.splice(index, 1);
                    this.props.dispatch({
                        type: 'LIVEROOM_BAN_LIST',
                        payload: list
                    })
                }
            })
    }

    handleBan() {
        this.context.page.showConfirm('温馨提示', '移除黑名单的用户将可在直播间的课程内发表评论', this.handleChangeList.bind(this));
    }

    hendleBeforeDeleteManage() {
        this.handleSheetHide();
        this.context.page.showConfirm('温馨提示', '是否确认移除管理员身份', this.handleDeleteManage.bind(this));
    }

    handleDeleteManage() {
        const {content, liveroomSetting} = this.props;
        axios.post(`/api/liveroom/${liveroomSetting.liveroom_id}/manager/${content.id}/delete`)
            .then(res => {
                if (res.data.code === 0){
                    /*let list = liveroomSetting.liveroomManage.managers;
                    let index = list.findIndex((value) => {
                        return content.id === value.id
                    });
                    list.splice(index, 1);
                    let data = liveroomSetting.liveroomManage;
                    data.managers = list;
                    this.props.dispatch({
                        type: 'LIVEROOM_MANAGE_INIT',
                        payload: data
                    })*/
                    axios.get(`/api/liveroom/${liveroomSetting.liveroom_id}/manager/list`)
                        .then(res => {
                            if (res.data.code === 0){
                                this.props.dispatch({
                                    type: 'LIVEROOM_MANAGE_INIT',
                                    payload: res.data.data
                                });
                                this.context.page.showToast('成功移除管理员');
                            }
                        })
                }
            })
    }

    handleBeConsulter() {
        const {content, liveroomSetting} = this.props;
        this.handleSheetHide();
        axios.post(`/api/liveroom/${liveroomSetting.liveroom_id}/manager/${content.id}/change_liveroom_consulter`)
            .then(res => {
                if (res.data.code === 0){
                    axios.get(`/api/liveroom/${liveroomSetting.liveroom_id}/manager/list`)
                        .then(res => {
                            if (res.data.code === 0){
                                this.props.dispatch({
                                    type: 'LIVEROOM_MANAGE_INIT',
                                    payload: res.data.data
                                });
                                this.context.page.showToast('设置客服成功');
                            }
                        })
                }
            })
    }

    renderIsConsulter() {
        const {content, liveroomSetting} = this.props;
        let manageList = liveroomSetting.liveroomManage.consulter;
        if (content.id === manageList.id){
            return (
                <p className="listitem-left-name-tips">客服</p>
            )
        }
    }


    render() {
        const {manageMenus, actionBottom, actionSheetShow} = this.state;
        const {itemType, content, hasBtn} = this.props;
        return (
            <div className="ban-page-listitem">
                <div className="listitem-left">
                    <div className="listitem-left-icon">
                        <img src={content.small_avatar_url} alt=""/>
                    </div>
                    <div className="listitem-left-name">
                        {content.nickname}
                        {itemType !== 'ban' &&
                            this.renderIsConsulter()
                        }
                    </div>
                </div>
                <div className="listitem-right ban-page-diglog">
                    <ActionSheet
                        menus={manageMenus}
                        actions={actionBottom}
                        show={actionSheetShow}
                        type="ios"
                        onRequestClose={e => this.setState({actionSheetShow: false})}
                    />
                    {hasBtn &&
                    <div className="listitem-right-btn"
                         onClick={itemType === 'ban' ? this.handleBan : this.handleSheetShow}>
                        {itemType === 'ban' ? '移除' : '操作'}
                    </div>
                    }
                </div>
            </div>
        )
    }
}

BanListItem.contextTypes = {
    page: React.PropTypes.object,
};

export default connect(state => ({
    liveroomSetting: state.liveroomSetting
}))(BanListItem)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/BanListItem.js